<template>
    <div>
        <div class="row" v-if="! isLoadingBlade && ! errorPage">
            <div id="main-slanted-display" class="col-lg-12">
                <div id="fh5co-wrapper">
                    <div id="fh5co-page">
                        
                        <!-- this is the header -->
                        <Header 
                            :menus="menus"
                            :params="params"
                        />
                        <!-- end:header-top -->
                        


                        <!-- Footer included here -->
                        <Footer 
                            :params="params"
                            :blog="blog"
                        />
                    
                    </div>
                    <!-- END fh5co-page -->
                </div>
            <!-- END fh5co-wrapper -->
            </div>
        </div>

        <div class="row" v-if="isLoadingBlade">
            <div class="col-lg-12 text-center" style="margin-top: 5%;">
                <img src="/images/loading.gif" :alt="getsiteName">
            </div>
        </div>

        <div class="row" v-if="! isLoadingBlade && errorPage">
            <div class="col-lg-12 text-center">
                <img src="/images/error-page.gif" :alt="getsiteName">
                <h1> 
                    <em class="text-danger">
                        {{ errorMsg }}
                    </em> 
                </h1>
                <router-link
                    to="/"
                    class="btn btn-lg btn-success"
                >
                    Back to Homepage
                </router-link>
                <br><br>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Header from '../layouts/Header.vue'
    import Footer from '../layouts/Footer.vue'

    export default {
        name: 'OtherContentCategory',
        components: {
            Header,
            Footer
        },
        data() {
            return {
                isLoadingBlade: true,
                errorPage: false,
                errorMsg: '',
                menus: [],
                params: {},
                blog: [],
                page: {}
            }
        },
        computed: {
            ...mapGetters(['getsiteName', 'paginateNo'])
        },
        methods: {
            ...mapActions(['getHomepageData', 'getOtherContentPages', 'getPaginationRecords']),
            paginate(url) {
                this.errorPage = false;
                this.isLoadingBlade = true;
                this.getPaginationRecords(url).then((res) => {// get paginated records
                    if(res.status == 200) { // set data
                        this.setData(res.data);
                    } else {
                        this.isLoadingBlade = false;
                        this.errorPage = true
                        this.errorMsg = 'Page was not able to load, reload page...'
                    }
                }).
                catch(() => {
                    this.isLoadingBlade = false;
                    this.errorPage = true
                    this.errorMsg = 'Page was not able to load, reload page...'
                });
            },
            loadPage() {
                this.errorPage = false;
                let data = { 'slug' : this.$route.params.slug, limit: this.paginateNo  };
                this.getOtherContentPages(data).then((res) => {// get homepage data
                    if(res.status == 200) { // set data
                        this.setData(res.data);
                    } else {
                        this.isLoadingBlade = false;
                        this.errorPage = true
                        this.errorMsg = 'Page was not able to load, reload page...'
                    }
                }).
                catch(() => {
                    this.isLoadingBlade = false;
                    this.errorPage = true
                    this.errorMsg = 'Page was not able to load, reload page...'
                });
            },
            setData(data) {
                this.menus = data.menus;// update menus
                this.params = data.parameters;// set parameters
                this.blog = data.blog; // set blog contents
                this.page = data.page;// get page content
                setTimeout(() => { this.isLoadingBlade = false; }, 1000)
            }
        },
        created() {
            this.loadPage(); // get page contents
        }
    }
</script>

<style lang="scss" scoped>

</style>